<template>
  <div class="clientList">
    <div>
      <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
      >
        <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
        >
          <div
            v-for="(v, k) in menus"
            :key="k"
            style="display: inline-block"
            v-auth="v.auth"
          >
            <MenuItem
              :name="v.name"
              @click="v.onClick"
              v-show="v.show === true ? false : true"
            >
              <Badge
                :overflow-count="10000000"
                v-if="v.badge && v.badge.count"
                :count="v.badge.count"
                :offset="[18, -3]"
              >
                {{ v.label }}
              </Badge>
              <span v-if="!(v.badge && v.badge.count)">
                {{ v.label }}
              </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%; margin-bottom: 20px; margin-top: 20px"
      row-key="id"
      border
      :default-expand-all="false"
      :tree-props="{ children: 'child', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="title" label="菜单名称" width="180">
      </el-table-column>
      <el-table-column prop="sort" width="80" align="center" label="排序">
      </el-table-column>
      <el-table-column prop="link" width="300" align="center" label="功能路径">
      </el-table-column>
      <el-table-column prop="isHome" label="菜单状态">
        <template slot-scope="scope">
          <div
            :style="{
              color:
                scope.row.isHome == 0
                  ? 'red'
                  : scope.row.isHome == 1
                  ? 'blue'
                  : '',
            }"
          >
            {{
              scope.row.isHome == 0
                ? "不显示"
                : scope.row.isHome == 1
                ? "显示"
                : ""
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <div
              style="
                margin-right: 10px;
                color: rgb(73, 145, 255);
                cursor: pointer;
              "
              @click="handleEdit(scope.row)"
            >
              编辑
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      menu_name: "",
      menus: [
        {
          label: "后台权限",
          name: "auth_group_list",
          auth: "",
        },
        {
          label: "用户权限",
          name: "weapp_client_list_item",
          auth: "",
          show: window.localStorage.getItem("customerId") != 0 ? false : true,
        },
        {
          label: "维修权限",
          name: "weapp_engineer_list_item",
          auth: "",
          show: window.localStorage.getItem("customerId") != 0 ? false : true,
        },
      ],
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    this.load();
  },
  methods: {
    async load() {
      const res = await $utils.api.load(
        "/admin/system/sysCustomerMobileFunction/list",
        { appType: 2 },
        "get"
      );
      if (res.code == 200) {
        this.tableData = res.rows;
      }
      console.log(res);
    },
    handleEdit(row) {
      $utils.url.push({
        name: "weapp_edit_item",
        query: { appType: 2, kv: row.id },
      });
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
  },
};
</script>

<style>
</style>